import { Deserializable } from '../_common/deserializable';

export class StreamKeyword implements Deserializable{
    id: number;
    shortCode: string;
    keyword: string;
    operator: string;
    country: string;
    timezone: string;
    min: number;
    rate: number;
    max: number;
    url: string;
    customizedUrl: string;
    replacementPairs: string;
    createdAt: number;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
